// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api",
});

// Request interceptor to attach access token & refresh if expired
api.interceptors.request.use(async (config) => {
  let access = localStorage.getItem("access_token");
  const refresh = localStorage.getItem("refresh_token");

  if (access) {
    try {
      const payload = JSON.parse(atob(access.split(".")[1]));
      const exp = payload.exp * 1000; // expiration in ms

      if (Date.now() > exp && refresh) {
        // access token expired, refresh it
        const res = await axios.post(`${api.defaults.baseURL}/token/refresh/`, {
          refresh,
        });
        localStorage.setItem("access_token", res.data.access);
        access = res.data.access;
      }
    } catch {
      // token is invalid/corrupt, log out
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/login";
      return Promise.reject("Token expired");
    }
    config.headers.Authorization = `Bearer ${access}`;
  }

  return config;
});
export default api;
